import { Button } from '@/components-new/button';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components-new/dialog';
import { CalculationDetails } from '@/features/market-baskets';

type CalculationLogDialogProps = {
  open: boolean;
  onClose: () => void;
  calculationDetails?: CalculationDetails;
};

export const CalculationLogDialog = ({ calculationDetails, open, onClose }: CalculationLogDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} size="2xl">
      <DialogTitle>Calculation Details</DialogTitle>
      <DialogBody>
        <pre className="max-h-[32rem] overflow-y-auto whitespace-pre-wrap rounded-lg bg-zinc-50 p-4 font-mono text-xs leading-relaxed text-zinc-700 ring-1 ring-zinc-200">
          {calculationDetails?.log ?? 'No details available.'}
        </pre>
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
